import { TOAST } from 'constants/general';
import { ToastContainer } from 'react-toastify';

const ToastMessage = () => {
  return (
    <ToastContainer
      limit={TOAST.LIMIT}
      draggable={false}
      pauseOnHover={false}
      pauseOnFocusLoss={false}
      autoClose={TOAST.AUTO_CLOSE.DEFAULT}
      toastClassName='w-fit max-w-[80vw] sm:max-w-[60vw] md:max-w-[50vw] ~px-4/10'
    />
  );
};

export default ToastMessage;
